import App from 'app/app.js';
import 'app/store/JobStore.js';
import 'app/store/RewardStore.js';
import 'app/store/ContentStore.js';
import 'app/store/UserProfileStore.js';

function AnalyticsService(
  $location,
  $window,
  $rootScope,
  ErrorLogService,
  JobStore,
  VisualMerchandiseStore,
  RewardStore,
  ContentStore,
  UserProfileStore,
  $filter,
  $injector,
  TranslateProviderService,
  $routeParams,
  SiteSectionsConstants,
  PageNameConstants,
  SubjectStore
) {
  const PREORDER = 'PREORDER';

  this.events = {
    PAGE_CHANGE: 'page_change',
    LANG_CHANGE: 'mlt_gbl_lang',
    ADD_STUDENT: 'mlt_add_student',
    EDIT_PROFILE: 'mlt_edit_profile',
    CHANGE_PASSWORD: 'mlt_chg_password',
    FIND_ID: 'mlt_hp_findID',
    CONTINUE_SHOPPING_SPEC: 'mlt_cont_spec',
    CART_REWARDS_ENGAGEMENT: 'mlt_cart_rewards',
    CART_REPRICE: 'mlt_cart_contents_changed',
    ACTIVE_SKU_CHANGE: 'mlt_active_productID_change',
    CART_ADD: 'cart add',
    COUPON_CODE_APPLIED: 'couponCodeApplied',
    CART_ITEM_REMOVE: 'scRemove',
    ITEM_CLICKED: 'selectItem_',
    NEW_ITEM: 'newItem_',
    PACKAGE_NEXT_STEP: 'packageNextStep',
    UPSELL_SHOWN: 'upsell_shown',
    UPSELL_CART_ADDED: 'upsell_cart_add',
    UPSELL_CLICK: 'upsell_click',
    PAYPAL_START: 'paymentEventStartedpaypal',
    PAYPAL_ERROR: 'paymentEventErrorpaypal',
    PAYPAL_CANCEL: 'paymentEventCancelledpaypal',
    PAYLATER_START: 'paymentEventStartedpaypalpayin4',
    PAYLATER_ERROR: 'paymentEventErrorpaypalpayin4',
    PAYLATER_CANCEL: 'paymentEventCancelledpaypalpayin4',
    VENMO_START: 'paymentEventStartedVenmo',
    VENMO_CANCEL: 'paymentEventCancelledVenmo',
    VENMO_ERROR: 'paymentEventErrorVenmo',
    APPLEPAY_START: 'paymentEventStartedApplepay',
    APPLEPAY_CANCEL: 'paymentEventCancelledApplepay',
    APPLEPAY_ERROR: 'paymentEventErrorApplepay',
    PAYMENT_PAGE_START: 'paymentPageStart',
    PAYMENT_PAGE_CANCEL: 'paymentPageCancel',
    PAYMENT_PAGE_ERROR: 'paymentPageError'
  };

  // the following events are add to the adobe events array
  this.ADOBE_EVENTS = {
    SWITCH_STUDENT: 'switchStudent',
    SWITCH_EVENT: 'switchEvent',
    FORM_LOAD: 'formLoad',
    FORM_ERROR: 'formError',
    FORM_SUCCESS: 'formSuccess',
    ADD_STUDENT: 'addStudent'
  };
  // the following events are add to the adobe error array
  this.ADOBE_ERROR_DESCRIPTIONS = {
    INVALID_EMAIL: 'invalid email',
    INVALID_INVALID_PDI: 'invalid picture day id',
    INVALID_INVALID_LT_CODE: 'invalid lifetouch code',
    INVALID_FORM: 'invalid form',
    SEARCH_ERROR: 'search error',
    SYSTEM_ERROR: 'System Error',
    SECURITY_FAILURE: 'Security Challenge Failure',
    GENERIC_ERROR: 'Generic Error'
  };
  this.ADOBE_FORM_IDS = {
    GUEST_LOGIN_CODE: 'guest-login-code',
    GUEST_FIND_MY_PICTURE_DAY: 'guest-find-my-picture-day',
    GUEST_LOGIN_STUDENTID: 'guest-login-studentid',
    GUEST_LOGIN_PORTRAITID_DETAIL: 'guest-login-portraitid-detail',
    GUEST_LOGIN_PICTUREID_DETAIL: 'guest-login-pictureid-detail',
    LOGIN_SHUTTERFLY_ACCOUNT: 'login-shutterfly-account',
    ADD_NEW_STUDENT_CODE: 'add-new-student-code',
    ADD_NEW_STUDENT_ID: 'add-new-student-id',
    STUDENT_ADD: 'StudentAdd',
    FIND_MY_STUDENT_SMILESAFE: 'find-my-student-smilesafe',
    FIND_MY_STUDENT_ACCESS_CODE: 'find-my-student-access-code'
  };

  this.activeSku = null;
  this.couponCode = null;
  this.cartItems = null;
  this.totalCartQty = 0;
  this.eventType = null;

  $rootScope.$on('$viewContentLoaded', () => {
    // GTM
    this.updateContentView(true);

    // Adobe Omniture
    this.recordEvent(this.events.PAGE_CHANGE);
  });

  const appendOrderType = (virtualUrl) => {
    let orderType = JobStore.getOrderType();

    if (!!orderType) {
      orderType = R.find(R.propEq('name', orderType))(ContentStore.getEnum('OrderType').values).code;

      if (virtualUrl.indexOf('?') >= 0) {
        virtualUrl = virtualUrl.replace('?', `?orderType=${orderType}&`);
      } else if (virtualUrl.indexOf('#') >= 0) {
        virtualUrl = virtualUrl.replace('#', `?orderType=${orderType}#`);
      } else {
        virtualUrl = `${virtualUrl}?orderType=${orderType}`;
      }
    }
    return virtualUrl;
  };

  const getVirtualUrl = () => {
    const path = $location.path();
    const absUrl = $location.absUrl();
    return path === '/'
      ? absUrl.substring(absUrl.lastIndexOf(path), absUrl.length)
      : absUrl.substring(absUrl.indexOf(path));
  };

  const getSiteDomain = () => $location.host();

  this.getItemDesc = () => {
    const currentSubject = this.getCurrentSubject();
    const newItem = [];

    if (!currentSubject) {
      return newItem;
    }

    const currentOrderLine = currentSubject
      .getOrderLines()
      ?.filter((orderLine) => orderLine.orderable?.skuCode === this.activeSku)
      ?.pop();

    if (!currentOrderLine) {
      return newItem;
    }

    currentOrderLine.orderLineDetails?.forEach((orderLineDetail) => {
      if (orderLineDetail?.item && orderLineDetail?.look) {
        newItem.push({
          itemDescription: orderLineDetail.item.displayGroup,
          lookNum: orderLineDetail.look.lookNumber,
          background: orderLineDetail.look.background?.premiumUpgrade ? 'PREMIUM' : 'STANDARD',
          layoutThemeId: orderLineDetail.look.layoutThemeID
        });
      }
    });

    return newItem;
  };

  const getRoute = () => {
    const RouterService = $injector.get('RouterService');
    const virtualUrl = getVirtualUrl();
    const route = RouterService.getRoute(virtualUrl);

    /**
     *  Some controllers use a dynamic page param in their route, for analytics we want these to have separate names.
     */
    if (!!route && !!$routeParams.page) {
      return route.originalPath.replace(':page', $routeParams.page);
    }

    return !!route ? route.originalPath : virtualUrl;
  };

  const getSiteSection = (path) => SiteSectionsConstants[path] || 'main';

  const getAdobeEnv = () => window.adobeEnv?.environment || '';

  // The build index.gsp served this page, and why (canary, baseline, ...), so reports can compare cohorts.
  const getFrontendBuild = () => ({
    frontendVersion: $window.frontendVersion || null,
    frontendCohort: $window.frontendCohort || null
  });

  const getPageName = (path, activeOrderLine) => {
    let pageName = PageNameConstants[path];
    const productNamePattern = /{productName}/;
    const slashPattern = /\//g;
    if (!!pageName) {
      const productName = this.getProductName(activeOrderLine);
      pageName = pageName.replace(productNamePattern, productName);
    } else {
      pageName = path.replace(slashPattern, '');
    }

    return pageName;
  };
  const getLifetouchUserProfileId = () => {
    if (Boolean(UserProfileStore.isLoggedIn())) {
      return UserProfileStore.getLifetouchUserProfileId() || null;
    }
    return null;
  };

  const getMFRStatus = () => {
    if (!UserProfileStore.isLoggedIn()) {
      return null;
    }
    if (UserProfileStore.isLoyaltyUser()) {
      return 'Loyalty User';
    }
    return 'Non-Loyalty User';
  };

  const getSubjectGrade = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    return shoppingCartStore.getCurrentSubject()?.subjectGrade || null;
  };

  const getCountryCode = () => (TranslateProviderService.isCanadianDomain() ? 'Canada' : 'US');

  const getBusinessLine = () => (TranslateProviderService.isCanadianDomain() ? 'MLT.ca' : 'MLT.com');

  const getCartTotal = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    if ($location.path() === '/review-order') {
      return shoppingCartStore.getTotal() || null;
    }
    return shoppingCartStore.getTotalWithoutTax() || null;
  };

  const getCognitoProfileId = () => {
    if (Boolean(UserProfileStore.isLoggedIn())) {
      return UserProfileStore.getCognitoProfileId() || null;
    }
    return null;
  };

  const getRelationshipToStudent = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    const currentSubject = shoppingCartStore.getCurrentSubject();
    return currentSubject?.subjectRelationship || null;
  };

  const getLid = () => (JobStore.getJob() && JobStore.getJob().lifetouchId) || null;

  const getPhotoProgram = () => JobStore.getJob()?.photoProgram || null;

  const getApo = () => JobStore.getJob()?.apoKey || null;

  const isPreOrder = () => {
    const orderType = JobStore.getOrderType();
    return orderType ? orderType === PREORDER : null;
  };

  const getAccountName = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    return shoppingCartStore.getCurrentSubject()?.portraitDashboard?.accountName || null;
  };

  const getDollarsRemainingForCoupon = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    if (Boolean(UserProfileStore.isLoggedIn()) && UserProfileStore.userProfile.rewards) {
      let total = 0;
      const data = UserProfileStore.userProfile.rewards;

      for (let i = 0, len = data.inprogress.length; i < len; i++) {
        if (data.inprogress[i].rewardProgramCode === '10PERCENTOFF_65') {
          const reward = data.inprogress[i];
          total = (
            (reward.rewardThreshold * 100 - reward.currentPoint * 100 - (shoppingCartStore.getTotal() || 0) * 100) /
            100
          ).toFixed(2);
        }
      }

      return total || null;
    }

    return null;
  };

  const getPackagePriceList = () => JobStore.getJob()?.packagePriceList || null;

  const isLoggedIn = () => !!UserProfileStore.isLoggedIn();

  const getCartItems = (orderLines) => {
    const cartItems = [];
    let cartQty = 0;

    if (orderLines !== null && orderLines.length > 0) {
      R.map((orderLine) => {
        cartQty = cartQty + orderLine.length;
        R.map((order) => {
          cartItems.push({
            productName: order.name,
            basePrice: order.price,
            sku: order.id,
            quantity: order.quantity
          });
        })(orderLine);
      })(orderLines);
    }
    this.totalCartQty = cartQty;
    return cartItems;
  };

  let localModuleInfo = {};
  this.updateModuleInfo = (activeOrderLine, eventName) => {
    if (eventName === this.events.UPSELL_SHOWN) {
      if (activeOrderLine?.orderable?.upsellProducts?.length > 0) {
        let driverProductName = null;
        const productName = this.getProductName(activeOrderLine);
        if (productName) {
          driverProductName = `${productName} ${this.capitalizeFirstLetter(activeOrderLine.orderable.skuCategory)}`;
        }
        localModuleInfo = {
          moduleName: 'popup-upsell',
          moduleType: 'upsell',
          driverSKU: this.getProductSku(activeOrderLine),
          driverProductName,
          item: this.getModuleItems(activeOrderLine)
        };
      } else {
        localModuleInfo = {};
      }
    } else if (
      eventName === this.events.PAGE_CHANGE ||
      eventName === this.events.CART_ADD ||
      eventName === this.events.UPSELL_CART_ADDED ||
      eventName === this.events.UPSELL_CLICK
    ) {
      localModuleInfo = {};
    }
    return localModuleInfo;
  };

  this.capitalizeFirstLetter = (anyText) => {
    if (anyText && anyText.length > 0) {
      return anyText.charAt(0).toUpperCase() + anyText.substr(1).toLowerCase();
    }
    return anyText;
  };

  this.getModuleItems = (activeOrderLine) => {
    const upsellItems = [];
    if (activeOrderLine) {
      if (activeOrderLine && activeOrderLine.orderable && activeOrderLine.orderable.upsellProducts.length > 0) {
        R.forEach((orderLineDetail) => {
          upsellItems.push({
            sku: orderLineDetail.skuCode ? orderLineDetail.skuCode : null,
            productType: orderLineDetail.skuCategory ? orderLineDetail.skuCategory : null,
            productName: orderLineDetail.nameDesc ? orderLineDetail.nameDesc : null,
            basePrice: orderLineDetail.salePrice ? orderLineDetail.salePrice : 0.0,
            onSale: false,
            dynamicPrice: orderLineDetail.salePrice > orderLineDetail.discountedPriceWithPackage
          });
        })(activeOrderLine.orderable.upsellProducts);
      }
      return upsellItems;
    }
  };

  this.orderedSubjectsData = [];

  this.setOrderedSubjects = (data) => {
    this.orderedSubjectsData = data;
  };

  this.getOrderedSubjectsData = () => this.orderedSubjectsData;

  this.getSubjectsForAdobe = () => {
    const url = getRoute();
    const isOrderReceiptPage = url.includes('order-receipt');
    const orderedSubjects = this.getOrderedSubjectsData();
    return getTransformedSubjects(isOrderReceiptPage, orderedSubjects);
  };

  const getTransformedSubjects = (isOrderReceiptPage, orderedSubjects) => {
    const isUserLoggedIn = UserProfileStore.isLoggedIn();
    if (isUserLoggedIn && !isOrderReceiptPage) {
      const subjects = SubjectStore.getVerifiedSubjects();
      return transformedSubjects(subjects);
    }
    if (isUserLoggedIn && isOrderReceiptPage) {
      return transformedSubjects(orderedSubjects);
    }

    return [];
  };

  const transformedSubjects = (allSubjects) => {
    const transformedSubjectsForAdobe = [];
    for (let i = 0; i < allSubjects.length; i++) {
      if (allSubjects[i].ltMasterSubjectUuid) {
        transformedSubjectsForAdobe.push({
          id: allSubjects[i].ltMasterSubjectUuid,
          autoClaim: true
        });
      }
    }
    return transformedSubjectsForAdobe;
  };

  this.addAdobeFormSuccessEvent = (formId) => {
    this.addAdobeEvent({ event: this.ADOBE_EVENTS.FORM_SUCCESS, form: { id: formId } });
  };

  this.addAdobeFormErrorEvent = (formId, errorDescription) => {
    this.addAdobeEvent({
      event: this.ADOBE_EVENTS.FORM_ERROR,
      error_description: errorDescription || '',
      form: { id: formId }
    });
  };

  this.addAdobeFormLoadEvent = (formId) => {
    this.addAdobeEvent({ event: this.ADOBE_EVENTS.FORM_LOAD, form: { id: formId } });
  };

  this.addStudentViaStudentIdFlow = (studentId) => {
    this.addAdobeEvent({ event: this.ADOBE_EVENTS.ADD_STUDENT, form: { student_id: studentId } });
  };

  this.addAdobeEvent = (event) => {
    if (!$window.LT_DTL) {
      $window.LT_DTL = {
        events: $window.digitalData.events
      };
    } else if (!$window.LT_DTL.events) {
      $window.LT_DTL.events = $window.digitalData.events;
    }
    $window.LT_DTL.events.push(event);
  };

  const updateAdobeDL = (eventName) => {
    try {
      const lifetouchProfileId = getLifetouchUserProfileId();
      const route = getRoute();
      const activeSubject = this.recordOrderActiveSubject();
      const allSubjectOrderLines = this.recordOrderAllSubjects();
      const activeOrderLine = this.getActiveOrderLine();
      $window.digitalData = {
        events: $window.digitalData?.events || []
      };
      $window.LT_DTL = {
        // $window.digitalData.events is initialized in index.gsp
        events: $window.digitalData.events,
        session: {
          partner: {
            brand: 'Lifetouch',
            businessLine: getBusinessLine()
          },
          visitorDetails: {
            visitorType: !!lifetouchProfileId ? 'SignedIN' : 'Guest',
            customerId: lifetouchProfileId,
            cognitoUserProfileId: getCognitoProfileId()
          },
          siteType: 'ecomm',
          siteDomain: getSiteDomain(),
          build: getFrontendBuild()
        },
        page: {
          pageInfo: {
            pageName: getPageName(route, activeOrderLine),
            siteSection: getSiteSection(route),
            siteEnv: getAdobeEnv()
          }
        },
        data: {
          jobNumber: JobStore.getJob()?.jobNumber,
          portraitId: JobStore.getJob()?.portraitId,
          accessCode: JobStore.getJob()?.accessCode,
          sellingMethod: JobStore.getSellingMethod(),
          orderType: JobStore.getOrderType(),
          isPreOrder: isPreOrder(),
          subProgramName: JobStore.getSubProgramName(),
          loyaltyStatus: getMFRStatus(),
          packagePriceList: getPackagePriceList(),
          apo: getApo(),
          lid: getLid(),
          mfrCurrent_10PERCENTOFF_65: getDollarsRemainingForCoupon(),
          schoolName: getAccountName(),
          grade: getSubjectGrade(),
          relationshipToStudent: getRelationshipToStudent(),
          photoProgram: getPhotoProgram(),
          cartTotal: getCartTotal(),
          activeCartContents: activeSubject,
          poseCount: VisualMerchandiseStore.getPoseCount(),
          enhancements: {
            ng:
              $window.LT_DTL &&
              $window.LT_DTL.data &&
              $window.LT_DTL.data.enhancements &&
              $window.LT_DTL.data.enhancements.ng,
            retouching:
              $window.LT_DTL &&
              $window.LT_DTL.data &&
              $window.LT_DTL.data.enhancements &&
              $window.LT_DTL.data.enhancements.retouching
          },
          sku: getCartSkus()
        },
        product: {
          productInfo: {
            sku: this.getProductSku(activeOrderLine),
            productType: this.getProductType(activeOrderLine),
            productName: this.getProductName(activeOrderLine),
            basePrice: this.getBasePrice(activeOrderLine),
            onSale: false,
            item: this.getItemDesc()
          }
        },
        cart: {
          item: getCartItems(allSubjectOrderLines),
          cartTotal: getCartTotal(),
          cartQuantity: this.totalCartQty,
          promo: {
            couponcode: this.couponCode //register as its applied
          }
        },
        subject: this.getSubjectsForAdobe(),
        transaction: this.transaction,
        moduleInfo: this.updateModuleInfo(activeOrderLine, eventName)
      };

      if (
        this.eventType === this.events.CART_ADD &&
        activeOrderLine?.orderable?.skuCategory?.toUpperCase() !== 'PACKAGE'
      ) {
        $window.LT_DTL.product.productInfo.dynamicPrice = this.getDynamicPrice(activeOrderLine);
      }

      if (this.eventType === this.events.UPSELL_CART_ADDED) {
        $window.LT_DTL.product.productInfo.dynamicPrice = this.getDynamicPrice(activeOrderLine);
      }
    } catch (e) {
      e.message = `Failed to update Adobe Data Layer: ${e.message}`;
      ErrorLogService(e);
    }
  };

  this.getProductName = (activeOrderLine) => activeOrderLine?.orderable?.nameDesc;

  this.getBasePrice = (activeOrderLine) => activeOrderLine?.orderable?.salePrice || 0.0;

  this.getDynamicPrice = (activeOrderLine) => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    const currentSubject = shoppingCartStore.getCurrentSubject();
    return Boolean(
      currentSubject?.packages?.length > 0 &&
      activeOrderLine?.orderable?.discountedPriceWithPackage &&
      activeOrderLine.orderable.salePrice > activeOrderLine.orderable.discountedPriceWithPackage
    );
  };

  this.getProductSku = (activeOrderLine) => activeOrderLine?.orderable?.skuCode;

  this.getProductType = (activeOrderLine) => activeOrderLine?.orderable?.skuCategory;

  this.getActiveOrderLine = () => {
    const productCatalogStore = $injector.get('ProductCatalogStore');
    return productCatalogStore.getActiveOrderLine(this.activeSku);
  };

  this.getCurrentSubject = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    return shoppingCartStore.getCurrentSubject();
  };

  this.setCouponCode = (code) => {
    this.couponCode = code;
  };

  this.setCartItems = (items) => {
    const cartItems = [];

    for (let i = 0, len = items.length; i < len; i++) {
      cartItems.push({
        productInfo: {
          productID: items[i]
        }
      });
    }

    this.cartItems = cartItems;
  };

  const dispatchEvent = (eventName) => {
    try {
      const customEvent = new $window.CustomEvent(eventName);
      $window.document.body.dispatchEvent(customEvent);
    } catch (e) {
      e.message = `Failed to dispatch CustomEvent for Adobe: ${e.message}`;
      ErrorLogService(e);
    }
  };

  this.registerEvent = (eventName) => {
    if (window.adobeDebugFlag) {
      window.registerEvent(eventName);
    }
  };

  this.recordEvent = (eventName) => {
    this.eventType = eventName;
    updateAdobeDL(eventName);
    this.eventType = null;
    dispatchEvent(eventName);
  };

  this.recordEnhancementSelected = (productCode, isPersonalization) => {
    let eventName;
    try {
      updateAdobeDL(eventName);
      if (isPersonalization) {
        $window.LT_DTL.data.enhancements.ng = productCode;
      } else {
        $window.LT_DTL.data.enhancements.retouching = productCode;
      }
    } catch (e) {
      e.message = `Failed to Record Enhancement Selected: ${e.message}`;
      ErrorLogService(e);
    }
  };

  this.updateContentView = (isContentLoaded) => {
    const event = isContentLoaded ? 'content-view' : 'content-changed';
    try {
      $window.dataLayer.push({
        event,
        'content-name': appendOrderType(getVirtualUrl()),
        activeCartContents: this.recordOrderActiveSubject(),
        sellingMethod: JobStore.getSellingMethod(),
        lifetouchUserProfileId: getLifetouchUserProfileId(),
        orderType: JobStore.getOrderType(),
        isPreOrder: isPreOrder(),
        subProgramName: JobStore.getSubProgramName(),
        photoProgram: getPhotoProgram(),
        loyaltyStatus: getMFRStatus(),
        countryCode: getCountryCode(),
        ecommerce: undefined,
        error_message: undefined,
        school: getAccountName(),
        grade: getSubjectGrade(),
        error_id: undefined,
        cartTotal: getCartTotal(),
        lifetouchId: getLid(),
        apo: getApo(),
        website: 'MLT',
        loggedInStatus: isLoggedIn(),
        mfrCurrent_10PERCENTOFF_65: getDollarsRemainingForCoupon(),
        packagePriceList: getPackagePriceList(),
        cognitoUserProfileId: getCognitoProfileId()
      });
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      ex.message = `Failed to update GTM Data Layer: ${ex.message}`;
      ErrorLogService(ex);
    }
  };

  this.getAccountName = () => getAccountName();

  this.getDollarsRemainingForCoupon = () => getDollarsRemainingForCoupon();

  this.isLoggedIn = () => isLoggedIn();

  const getOrderCoupons = (subject) => R.map((coupon) => coupon.promotionCode)(subject.orderPromotion);

  this.getSubjectGrade = () => getSubjectGrade();

  this.getCountryCode = () => getCountryCode();

  this.getCartTotal = () => getCartTotal();

  this.getApo = () => getApo();

  this.getLid = () => getLid();

  this.getPhotoProgram = () => getPhotoProgram();

  this.getPackagePriceList = () => getPackagePriceList();

  this.getCognitoProfileId = () => getCognitoProfileId();

  this.getRelationshipToStudent = () => getRelationshipToStudent();

  this.recordOrder = (data) => {
    let paymentMethod = '';
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    if (shoppingCartStore.payment.paymentType) {
      paymentMethod = shoppingCartStore.payment.paymentType.name
        ? shoppingCartStore.payment.paymentType.name.toLowerCase()
        : '';
    }
    const transaction = {
      purchaseID: data.payment.paymentServiceResponse.externalPaymentAttemptId,
      paymentMethod,
      shoppedNumberOfStudents: shoppingCartStore.getSubjects().length,
      totalRevenue: shoppingCartStore.getTotal(),
      salesTax: shoppingCartStore.getTotalTaxAmount(),
      shippingCharge: shoppingCartStore.getShippingUnitPrice(),
      surcharge: shoppingCartStore.getTotalFeesAmount(),
      item: []
    };

    const purchases = R.map((subject) => ({
      actionField: {
        id: shoppingCartStore.payment.paymentServiceResponse.externalPaymentAttemptId, //ShoppingCartStore.payment ? ShoppingCartStore.payment.paymentServiceResponse ? ShoppingCartStore.payment.paymentServiceResponse.externalPaymentAttemptId : null: null, // gaExternalTranId
        affiliation: 'MyLifetouch', // gaStoreName
        revenue: parseFloat(subject.totalAmount).toFixed(2), // gaTotal
        tax: subject.taxAmount, // gaTax
        shipping: subject.getShippingUnitPrice(), // gaShipping
        coupon: getOrderCoupons(subject).join()
      },
      products: R.map((orderLine) => {
        transaction.item.push({
          quantity: 1,
          price: {
            basePrice: orderLine.salesPrice
          },
          sku: this.getProductSku(orderLine),
          productName: this.getProductName(orderLine),
          productType: this.getProductType(orderLine)
        });
        return {
          name: orderLine.orderable.nameDesc, // gaProdName
          id: orderLine.orderable.skuCode, // gaSku
          price: orderLine.salesPrice, // gaProdPrice
          category: orderLine.orderable.productCode, // gaProdCode
          quantity: 1, // gaQuantity
          coupons: R.map((coupon) => ({ promotionCode: coupon.promotionCode, amount: coupon.amount }))(
            orderLine.orderPromotion
          )
        };
      })(subject.getOrderLines()),
      coupons: R.map((coupon) => ({ coupon: coupon.promotionCode, amount: coupon.amount }))(subject.orderPromotion)
    }))(shoppingCartStore.getSubjects());

    R.forEach((purchase) => {
      try {
        $window.dataLayer.push({
          ecommerce: { purchase },
          event: 'order-data',
          'content-name': undefined,
          sellingMethod: undefined,
          lifetouchUserProfileId: undefined,
          orderType: undefined,
          isPreOrder: undefined,
          subProgramName: undefined,
          loyaltyStatus: undefined,
          error_message: undefined,
          error_id: undefined
        });
      } catch (ex) {
        // This try-catch block was placed to ensure it doesn't break the flow
        console.debug(ex);
      }
    })(purchases);

    this.transaction = transaction;
    let eventName;
    updateAdobeDL(eventName);
  };

  this.recordOrderActiveSubject = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    const subject = shoppingCartStore.getCurrentSubject();

    if (!subject) {
      return null;
    }

    return R.map((orderLine) => ({
      name: orderLine.orderable.nameDesc, // gaProdName
      id: orderLine.orderable.skuCode, // gaSku
      price: orderLine.salesPrice, // gaProdPrice
      category: orderLine.orderable.productCode, // gaProdCode
      quantity: 1, // gaQuantity
      coupons: R.map((coupon) => ({ promotionCode: coupon.promotionCode, amount: coupon.amount }))(
        orderLine.orderPromotion
      )
    }))(subject.getOrderLines());
  };

  this.getOrderLine = (subject) => {
    if (!subject) {
      return null;
    }
    return R.map((orderLine) => ({
      name: orderLine.orderable.nameDesc, // gaProdName
      id: orderLine.orderable.skuCode, // gaSku
      price: orderLine.salesPrice, // gaProdPrice
      category: orderLine.orderable.productCode, // gaProdCode
      quantity: 1, // gaQuantity
      coupons: R.map((coupon) => ({ promotionCode: coupon.promotionCode, amount: coupon.amount }))(
        orderLine.orderPromotion
      )
    }))(subject.getOrderLines());
  };

  this.recordOrderAllSubjects = () => {
    const orderLines = [];
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    const subjects = shoppingCartStore.getAllSubjects();

    if (subjects && subjects.length > 0) {
      R.map((subject) => {
        if (subject) {
          const order = this.getOrderLine(subject);

          if (order && order.length > 0) orderLines.push(order);
        }
      })(subjects);
    }
    return orderLines;
  };

  const getCartSkus = () => {
    const shoppingCartStore = $injector.get('ShoppingCartStore');
    const subjects = shoppingCartStore.getSubjects();
    let cartSkusBySubject = [];

    if (subjects.length > 0) {
      cartSkusBySubject = R.map((subject) =>
        R.map((orderLine) => orderLine.orderable.skuCode)(subject.getOrderLines())
      )(subjects);
      return cartSkusBySubject;
    }
    return null;
  };

  this.setActiveSku = (sku) => {
    this.activeSku = sku;
  };

  this.recordError = (errorCode) => {
    try {
      $window.dataLayer.push({
        error_message: $filter('ltTranslateFilter')(errorCode, {}),
        error_id: errorCode,
        event: 'errorMessage',
        // added to override the previous values.
        'content-name': undefined,
        sellingMethod: undefined,
        orderType: undefined,
        isPreOrder: undefined,
        subProgramName: undefined,
        loyaltyStatus: undefined
      });
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      console.debug(ex);
    }
  };

  this.recordSuggestiveSellingDisplayed = () => {
    try {
      $window.dataLayer.push({ event: 'suggestedProduct' });
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      console.debug(ex);
    }
  };

  this.recordActiveAddOnCategory = (addOnCategory) => {
    try {
      $window.dataLayer.push({ event: 'productCategory', 'addon category': addOnCategory });
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      console.debug(ex);
    }
  };

  this.recordRemoveFromCart = (product) => {
    try {
      $window.dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          remove: {
            // 'remove' actionFieldObject measures.
            products: [
              {
                //  removing a product to a shopping cart.
                name: product.nameDesc,
                id: product.skuCode,
                price: parseFloat(product.unitPrice).toFixed(2),
                brand: '',
                category: '',
                variant: '',
                quantity: 1
              }
            ]
          }
        }
      });
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      console.debug(ex);
    }
  };

  this.recordLeaveWebsite = () => {
    try {
      const shoppingCartStore = $injector.get('ShoppingCartStore');
      if (shoppingCartStore.getNumberOfItemsInCart() > 0) {
        $window.dataLayer.push({ event: 'cart-full-exit' });
      }
    } catch (ex) {
      // This try-catch block was placed to ensure it doesn't break the flow
      console.debug(ex);
    }
  };
}

App.service('AnalyticsService', [
  '$location',
  '$window',
  '$rootScope',
  'ErrorLogService',
  'JobStore',
  'VisualMerchandiseStore',
  'RewardStore',
  'ContentStore',
  'UserProfileStore',
  '$filter',
  '$injector',
  'TranslateProviderService',
  '$routeParams',
  'SiteSectionsConstants',
  'PageNameConstants',
  'SubjectStore',
  AnalyticsService
]);

App.run([
  'AnalyticsService',
  function (AnalyticsService) {
    // eagerly initialize the service
  }
]);
